module.exports = __webpack_public_path__ + "static/media/good.cbae2dfd.gif";